// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__6_Ql4","actionsCol":"EnrolledClinics_actionsCol__CnnYy"};